import React, { useContext, useEffect, useState } from "react";
// import ApiConfig from "../../../api/ApiConfig.js";
import { deleteWithAuthCall, simpleGetCall, simplePatchCall } from "../../../api/ApiServices.js";
import { AppContext } from "../../../context/AppContext.js";
import Loader from "../../Loader.js";
import NoData from "../../../sharedComponent/NoData.js";

import { useNavigate } from "react-router-dom";
import { notifySuccess } from "../../../toaster/notify.js";
import StoreSelector from "../../StoreSelector";
const StoreManage = () => {

  const navigate = useNavigate();
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

  const [data, setData] = useState([]);


  const { sidebar, 
    selectedStoreID, 
    setSelectedStoreID, 
    setSelectedRestID, 
    setSelectedRestName, 
    permissions,
    storesList, 
    ApiConfig } = useContext(AppContext);
  const [Loading, setLoading] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

const handleStoreChange = (value) => {
    const matchedStore = storesList?.find(s => s.value === value);
    setSelectedStoreID(value);
    if (matchedStore) {
      setSelectedRestID(matchedStore.id);
      setSelectedRestName(matchedStore.label);
      localStorage.setItem("selectedStoreId", value);
    }
  };

  useEffect(() => {
    if (selectedStoreID) {
      fetchData();
    }
  }, [selectedStoreID]);

const fetchData = async () => {
  setLoading(true);
  try {
    const res = await simpleGetCall(
      `${ApiConfig.List_Print}${selectedStoreID}`
    );

      setData(res.data);
  
  } catch (error) {
    console.error("Error fetching store data:", error);
    setData([]);
  } finally {
    setLoading(false);
  }
};

const handleDelete = async (id) => {

  try {
    const res = await deleteWithAuthCall(`${ApiConfig?.DELETE_Print}${id}`);
    if (res.success) {
      notifySuccess(res.message);
      fetchData(); // refresh the list after deletion
    }

  } catch (err) {

  } finally {

  }
};


  
  return (
    <div className={sidebar ? "taskMain " : "cx-active taskMain"} id="cx-main">
      <div className="role-content ">
        <div className="sub-header-role ">
          <h6 className="mt-2">Kitchen Management</h6>
          {permissions && permissions["View Inventory Management"] && (
              <StoreSelector
                options={Array.isArray(storesList) ? storesList : []}
                value={selectedStoreID}
                onChange={handleStoreChange}
              />
            )}
        </div>

        {/* Filters and Add Store */}
        <div
          className="d-flex justify-between items-center mb-3 mt-2 "
          style={{ justifyContent: "end" }}
        >
          {/* <div className="flex space-x-4">
            <div className="flex space-x-4">
              <div className="flex-grow">
                <input
                  type="text"
                  placeholder="Search store..."
                  className="w-full px-2 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-blue-200 font-family font-size-14 second-heading"
                  onChange={(e) => setShopName(e.target.value)}
                />
              </div>
              <div className="flex justify-end">
                <div className="ml-2">
                  <DropdownManu
                    data={shopDropDownList}
                    onChange={handleShopTypeChange}
                    placeholder="Store Type"
                    selectedItem={selectedItem}
                    setSelectedItem={setSelectedItem}
                    className="text-center" // Ensure this class is applied to center the text
                    
                  />
                </div>
              </div>
            </div>
            <div>
              <div
                className="available_btn ms-3  text-gray-700  p-2 rounded font-size-14"
                style={{ width: "200px", height: "38px" }}
              >
                <Dropdown onSelect={handleSelect}>
                  <Dropdown.Toggle
                    id="dropdown-basic"
                    // className="w-full text-start bg-transparent border-none shadow-none btn-store"
                    className="available_btn w-full text-start btn-default text-black border-none shadow-none bg-transparent"
                    style={{
                      padding: 0,
                      boxShadow: "none",
                      backgroundColor: "red",
                    }}
                  >
                    {selectedOption}
                  </Dropdown.Toggle>

                  <Dropdown.Menu style={{ width: "100%" }}>
                    <Dropdown.Item eventKey="1">Open</Dropdown.Item>
                    <Dropdown.Item eventKey="0">Closed</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
            <button
              className="ml-4 px-4 py-2  transition focus:outline-none  text-white px-4 py-2 rounded  border-none font-family font-size-14 create-btn-sub-header"
              // style={{ backgroundColor: "transparent" }}
              style={{ backgroundColor: "#53B7E8", color: "#fff" }}
              onClick={() => {
                setShopName("");
                setShopType(""); // Clear dropdown selection
                setSelectedOption("Availability Mode");
                setShopStatus("");
                setSelectedItem(null);
              }}
            >
              Clear All Filters
            </button>
          </div> */}
          {permissions && permissions["Manage Kitchen Management"] && (
            <button
              className="create-btn-sub-header   font-family font-size-14"
              onClick={() => navigate("/StockDetails")}
              style={{ backgroundColor: "#53B7E8", color: "#fff" }}
            >
              Add New Printer +
            </button>
          )}
        </div>

        {/* Stores Grid */}
        {Loading ? (
          <Loader />
        ) : (
          <div className="row ">
            {data && data.length > 0 ? (
              data.map((item, index) => (
                <div
                  key={index}
                  className=" p-4 shadow-md col-6 border w-80% Cards_class "
                >
                  <h3 className="font-family font-size-14 dark-text font-weight-600">
                    {item.restaurant_name}
                  </h3>

                  <div className="flex gap-4 mt-2 d-flex align-items-center">
                    

                    {/* Store Details */}
                    

                    <div className="flex-grow" style={{ width: "100%" }}>
                      <div className="container">
                        <div className="row d-flex justify-content-between align-items-center">
                          {/* Dropdown Column */}
                            {permissions && permissions["Manage Kitchen Management"] && (
                          <div
                            className="col-md-auto col-12 mb-2 mb-md-0"
                            style={{
                              display: "flex",
                              width: "100%",
                              justifyContent: "end",
                            }}
                          >
                          
                          
                            <button
                              className=" border bg-white rounded blue-text foont-family font-size-14 px-2 py-2"
                              onClick={() =>
                                navigate(`/StockDetails/${item.id}`)
                                // navigate(`/StockDetails`)
                              }
                            >
                              Edit
                            </button> 
                        <button
  className="border bg-white rounded blue-text font-family font-size-14 px-2 py-2"
  onClick={() => handleDelete(item.id)}
>
  Delete
                      </button>

                          </div>
                            )}

                          {/* Edit Button Column */}
                          
                        </div>
                      </div>
                      
                      <div className="row">
                        <div className="col-md-6">
                          <p
                            className="second-heading font-family font-size-14 font-weight-500"
                          
                          >
                            {/* {item.restaurant_address} */}{" "}
                            <div>
                              <b>Print IP</b>
                            </div>{" "}
                            <div> {item.printer_ip_address}</div>
                          </p>
                          <p
                            className="second-heading font-family font-size-14 font-weight-500"
                            // style={{
                            //   display: "flex",
                            //   justifyContent: "space-between",
                            // }}
                          >
                            {/* {item.opening_time} - {item.closing_time} */}
                            <div>
                              {" "}
                              <b>Kitchen Name</b>{" "}
                            </div>{" "}
                            <div>  {item.kitchen_name}</div>
                          </p> 

                     <p className="second-heading font-family font-size-14 font-weight-500"
                            // style={{
                            //   display: "flex",
                            //   justifyContent: "space-between",
                            // }}
                          >
                            {/* {item.opening_time} - {item.closing_time} */}
                            <div>
                              {" "}
                              <b>Printer Status</b>{" "}
                            </div>{" "}
                            <div>  {item.printer_status}</div>
                          </p>

                        </div>
                        <div
                          className="col-md-6"
                          style={{ display: "flex", justifyContent: "end" }}
                        >
                          <div>
                            <p
                              className="second-heading font-family font-size-14 font-weight-500"
                              // style={{
                              //   display: "flex",
                              //   justifyContent: "space-between",
                              // }}
                            >
                              {/* Mobile Number: {item.restaurant_contact} */}
                              <div>
                                {" "}
                                <b>Connections Type</b>{" "}
                              </div>
                              <div> {item.connection_type}</div>
                            </p>
                            <p
                              className="second-heading font-family font-size-14 font-weight-500"
                              // style={{
                              //   display: "flex",
                              //   justifyContent: "space-between",
                              // }}
                            >
                              {/* Mobile Number: {item.restaurant_contact} */}
                              <div>
                                <b>Printer Port</b>{" "}
                              </div>{" "}
                              <div>{item.printer_port}</div>
                            </p> 


                             <p
                              className="second-heading font-family font-size-14 font-weight-500"
                              // style={{
                              //   display: "flex",
                              //   justifyContent: "space-between",
                              // }}
                            >
                              {/* Mobile Number: {item.restaurant_contact} */}
                              <div>
                                <b>Last Printer</b>{" "}
                              </div>{" "}
                              <div>{item.last_printed_at}</div>

                               <div>
                                <b>Parcel counter Printer</b>{" "}
                              </div>{" "}
                              <div>{item.is_counter_printer}</div>
                            </p>
                          </div>
                        </div>                        
                      </div>
                    </div>
             
                  </div>
                  
                </div>
              ))
            ) : (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: "200px" }}
              >
                <NoData />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default StoreManage;
